import { apiEndPoints } from "utils/api-endpoints";
import HTTPService from "utils/httpService";

export const chainCodeAPI = (data: any) => {
  return HTTPService.post(apiEndPoints.universeAPI.templates.chainCode, data);
};
